import { cn } from "@/lib/utils";
import { Children, Fragment, isValidElement, ReactNode } from "react";

interface HeaderProps {
  headline?: string;
  additionalClassName?: string;
  children?: ReactNode;
}

interface ContentProps {
  divider?: boolean;
  hasPadding?: boolean;
  children?: ReactNode;
}

interface MainLayoutProps {
  children?: ReactNode;
}

const Header = ({ headline, children, additionalClassName }: HeaderProps) => (
  <div
    className={cn(
      "border-border-wu text-headline-wu space-y-4 border-b px-4 py-4 md:px-6",
      additionalClassName
    )}
  >
    {headline && (
      <h1 className="text-headline-wu text-2xl font-semibold">{headline}</h1>
    )}
    {children}
  </div>
);

const Sticky = ({ headline, children, additionalClassName }: HeaderProps) => (
  <div
    className={cn(
      "border-border-wu bg-background sticky top-[73px] z-30 flex w-full justify-center border-b md:top-0",
      additionalClassName
    )}
  >
    {children}
  </div>
);

const Content = ({
  divider = true,
  hasPadding = true,
  children,
}: ContentProps) => {
  const childArray = Children.toArray(children);

  return (
    <div className={cn(divider && "divide-border-wu divide-y")}>
      {childArray.map((child, i) => {
        if (hasPadding) {
          return (
            <div key={i} className="px-6 py-4">
              {child}
            </div>
          );
        }

        return <Fragment key={i}>{child}</Fragment>;

        // Default case: padding
        return (
          <div key={i} className="px-6 py-4">
            {child}
          </div>
        );
      })}
    </div>
  );
};

const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <main>
      <div className="md:ml-80">
        <div className="md:px-8">
          <div className="md:border-border-wu mx-auto min-h-[calc(100vh-73px)] max-w-3xl md:min-h-screen md:border-x">
            {children}
          </div>
        </div>
      </div>
    </main>
  );
};

MainLayout.Header = Header;
MainLayout.Sticky = Sticky;
MainLayout.Content = Content;

export default MainLayout;
